/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './disableAccountInvites.defs.js'
export { main as default } from './disableAccountInvites.defs.js'
